export const headers = [
  "Invoice #",
  "Charges",
  "Due Date",
  "Payment Status",
  "Amount",
];
